import axios from 'axios'
import {Message} from 'element-ui';

axios.defaults.withCredentials = true

const service = axios.create({
    // baseURL: process.env.VUE_APP_BASE_API,
    timeout: 600000,
    // withCredentials: true,
    // crossDomain: true
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        return config
    },
    error => {
        // 处理请求错误 并抛出错误
        return Promise.reject(error);
        
    }
);

//响应拦截器即异常处理
service.interceptors.response.use(
    response => {
        return response
    }, err => {
        
        if (err && err.response) {
            // 错误状态码枚举
            switch (err.response.status) {
                case 400:
                    Message.error('400:错误请求');
                    console.log('错误请求')
                    break;
                case 401:
                    Message.error('401:未授权，请重新登录');
                    console.log('未授权，请重新登录')
                    break;
                case 403:
                    Message.error('403:拒绝访问');
                    console.log('拒绝访问')
                    break;
                case 404:
                    Message.error('404:请求错误,未找到该资源');
                    console.log('请求错误,未找到该资源')
                    break;
                case 405:
                    Message.error('405:请求方法未允许');
                    console.log('请求方法未允许')
                    break;
                case 408:
                    Message.error('408:请求超时');
                    console.log('请求超时')
                    break;
                case 500:
                    Message.error('500:服务器端出错');
                    console.log('服务器端出错')
                    break;
                case 501:
                    Message.error('501:网络未实现');
                    console.log('网络未实现')
                    break;
                case 502:
                    Message.error('502:网络错误');
                    console.log('网络错误')
                    break;
                case 503:
                    Message.error('503:服务不可用');
                    console.log('服务不可用')
                    break;
                case 504:
                    Message.error('504:网络超时');
                    console.log('网络超时')
                    break;
                case 505:
                    Message.error('505:http版本不支持该请求');
                    console.log('http版本不支持该请求')
                    break;
                default:
                    Message.error(err.response.status);
                    console.log(`连接错误${err.response.status}`)
            }
            
        } else {
            Message.error('连接服务失败，原因：无法请求到服务器');
            console.log('连接服务失败，原因：无法请求到服务器')
        }
        return Promise.resolve(err.response)
    })

export default service
